import useMiddleware from "@/helper/hooks/useMiddleware";

export default async function admin({ next, }) {
  // let isUserAdmin = store.user.name === "Admin";
  const { isAdmin } = await useMiddleware();
  if (isAdmin.value) {
    return next();
  }

  return next({
    name: "home",
  });
}
